export default (theme) => ({
  chatbubbleWrapper: {
    overflow: "auto",
    display: "flex",
    margin: "4px 4px",
    opacity: 1,
  },
  chatbubble: {
    backgroundColor: theme.palette.secondary.chatGreen,
    borderRadius: 20,
    margin: "0px 4px",
    maxWidth: "80%",
    padding: 8,
    width: "-webkit-fit-content",
  },
  chatbubbleOrientationNormal: {
    justifyContent: "flex-end",
  },
  recipientChatbubble: {
    backgroundColor: "#FFFFFF",
    color: theme.palette.secondary.charcoal,
    display: "flex",
    alignItems: "center",
    border: "1px solid #E7E7E7",
  },
  recipientChatbubbleOrientationNormal: {
    justifyContent: "flex-start",
  },
  cyText: {
    marginLeft: 4,
  },
  fade: {
    opacity: 0,
    transition: "opacity 500ms ease-in-out 200ms",
  },
  hide: {
    display: "none",
  },
  isSelected: {
    backgroundColor: theme.palette.primary.main,
    color: "#FFFFFF",
    fontWeight: "700",
  },
  bubble: {
    '& a': {
      color: theme.palette.primary.main
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/HelpWidget/components/ChatBubble/styles.js